// листинг в каталоге

// import { createApp } from "vue";
import { createApp , watch , ref } from 'vue/dist/vue.esm-bundler';
import { createPinia } from "pinia";
import { useContextStore } from '../../../../assets/site/js/contextStore.js'

function initCatalogPage(){

    const el = document.querySelector( '#filter-window' );
    if( el ){
        createApp(
            {
                setup(){

                    const contextStore = useContextStore();

                    let timeout_id = null;
                    const mobile_footer = ref( null );

                    function applyFilter(){

                        let parameters = [];

                        contextStore.data.filter.forEach(
                            parameter => {

                                let parameter_name = 'filter[' + parameter.slug + '][]=';

                                parameter.values.forEach(
                                    val => {
                                        if( val.select ){
                                            parameters.push( parameter_name + val.id );
                                        }
                                    }
                                )

                            }
                        );

                        parameters.sort();

                        let target_url = window.location.protocol + '//' + window.location.host + window.location.pathname + ( parameters.length ? '?' : '' ) + parameters.join( '&' );
                        window.location.assign( target_url );
                    }

                    watch(
                        () => contextStore.data.filter ,
                        () => {
                            if( timeout_id ){
                                clearTimeout( timeout_id );
                            }
                            if( window.getComputedStyle( mobile_footer.value , null ).display === 'none' ){
                                timeout_id = setTimeout( applyFilter , 1000 );
                            }
                        } ,
                        {
                            deep : true
                        }
                    )

                    return {
                        contextStore ,
                        mobile_footer ,
                        applyFilter
                    }
                }
            }
        )
            .use( createPinia() )
            .mount( el )
    }


}

document.addEventListener( "DOMContentLoaded" , initCatalogPage );
